export const OrderListPath = '/orders';
export const OrderDetailsPath = {
  path: '/orders/:orderId',
  withId: (id: string): string => {
    return OrderDetailsPath.path.replace(':orderId', id);
  },
};
